import script from "./AdminMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMembers.vue?vue&type=script&setup=true&lang=js"

import "./AdminMembers.vue?vue&type=style&index=0&id=b874b0e4&scoped=true&lang=css"
import "./AdminMembers.vue?vue&type=style&index=1&id=b874b0e4&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b874b0e4"]])

export default __exports__